import { createContext, ReactNode, useContext, useState, useEffect } from "react";
import { initializeApp } from 'firebase/app'; // <-- add this line
import { getFirestore, collection, getDocs } from 'firebase/firestore/lite';
import firebaseConfig from '../firebaseConfig';
import { Product } from "types/product";


type ProductsContextProps = {
  children: ReactNode;
};

type PorductsContextType = {
  products: Product[];
  urlThumb: string;
  setUrlThumb: (url: string) => void;
  setProducts: (products: Product[]) => void;
};

const initialValue = {
  products: [],
  urlThumb: "",
  setUrlThumb: () => {},
  setProducts: () => {},
};

export const ProductsContext = createContext<PorductsContextType>(initialValue);
ProductsContext.displayName = "Products";

const ProductProvider = ({ children }: ProductsContextProps) => {
  const [products, setProducts] = useState<Product[]>(initialValue.products);
  const [urlThumb, setUrlThumb] = useState<string>(initialValue.urlThumb);

  useEffect(() => {
    const fetchProducts = async () => {
      const app = initializeApp(firebaseConfig);
      const firestore = getFirestore(app);
      const productsCol = collection(firestore, 'ckbCollections');
      const productSnapshot = await getDocs(productsCol);
      const productList = productSnapshot.docs.map(doc => doc.data() as Product);
      setProducts(productList);
    };

    fetchProducts();
  }, []);

  return (
    <ProductsContext.Provider
      value={{ products, setProducts, setUrlThumb, urlThumb }}
    >
      {children}
    </ProductsContext.Provider>
  );
};

const useProduct = () => {
  const context = useContext(ProductsContext);
  return context;
};

export { useProduct, ProductProvider };
